import styled from 'styled-components'

export default styled.div`
  height: 1px;
  width: 100%;
  background-color: ${({ bgColor }) => (bgColor ? bgColor : 'var(--divider)')};
`
